import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import HookTextFormControl from './HookTextFormControl';

import PasswordHint, { passwordHintWrapperClassName } from 'components/FormControl/Password/PasswordHint';
import { Frame } from 'components/StyledTemplates/StyledTemplates';

import { isna } from 'utils/common-helper';

import eyeSlash from 'assets/icons/eye-slash.svg';
import eye from 'assets/icons/eye.svg';

type HookPasswordFormControlProps = {
    withHint?: boolean;
    [x: string]: any;
};

const HookPasswordFormControl = (props: HookPasswordFormControlProps) => {
    const { value: propsValue = '', onChange = () => {}, withHint = false, ...rest } = props;
    const [type, setType] = useState(props?.type ?? 'password');
    const form = useFormContext();
    const [value, setValue] = useState(props.value ?? '');
    useEffect(() => {
        setValue(propsValue);
    }, [propsValue]);
    return (
        <Wrapper anyErrors={!isna(form?.formState?.errors?.[props?.name])} className={passwordHintWrapperClassName}>
            <HookTextFormControl
                {...rest}
                type={type}
                value={value}
                isPassword={true}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setValue(e?.target?.value ?? '');
                    onChange?.({ target: { value: e?.target?.value ?? '' } });
                }}
            />
            <img
                onClick={() => {
                    setType(type === 'password' ? 'text' : 'password');
                }}
                className="eye-icon"
                src={type === 'password' ? eye : eyeSlash}
                alt="Eye"
            />
            {withHint && <PasswordHint value={value} isWithLabel={true} />}
        </Wrapper>
    );
};

const Wrapper = styled(Frame)<{ extra?: string; anyErrors?: any }>`
    align-items: flex-start;
    position: relative;

    .eye-icon {
        cursor: pointer;
        position: absolute;
        top: 2.25rem;
        right: calc(5px + ${(props) => (props?.anyErrors ? 20 : 0)}px);
        transform: translate(-50%, 50%);
        width: 18px;
    }
`;

export default HookPasswordFormControl;
